import { useState } from "react";

export function useEffort(initialEffort = "") {
    const [effort, setEffort] = useState(initialEffort);
    return { effort, setEffort };
}
